import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "m9 10.05-3.675 3.675a.71.71 0 0 1-.525.206.71.71 0 0 1-.525-.206.71.71 0 0 1-.207-.525q0-.318.207-.525L7.95 9 4.275 5.325a.71.71 0 0 1-.207-.525q0-.318.207-.525A.71.71 0 0 1 4.8 4.07q.318 0 .525.206L9 7.95l3.675-3.675a.71.71 0 0 1 .525-.206q.318 0 .525.206a.71.71 0 0 1 .206.525.71.71 0 0 1-.206.525L10.05 9l3.675 3.675a.71.71 0 0 1 .206.525.71.71 0 0 1-.206.525.71.71 0 0 1-.525.206.71.71 0 0 1-.525-.206z"
    }, null, -1)
  ]))]))
}
export default { render: render }